import styled from 'styled-components'
import { MyButtonLink } from '@global/styles'
import { regular, medium } from '@global/fonts'

export const ProfileLink = styled(MyButtonLink)`
  ${regular};
  ${medium};
`
